import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { SITE } from "../lib/config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ContactForm = ({ compact = false, subject = "Solicitud de cita", testId = "contact-form" }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) {
      toast.error("Debes aceptar la Política de Privacidad para continuar.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, { ...form, consent, subject });
      toast.success("¡Gracias! He recibido tu mensaje y te responderé muy pronto.");
      setForm({ name: "", email: "", phone: "", message: "" });
      setConsent(false);
    } catch (err) {
      toast.error("No se pudo enviar. Inténtalo de nuevo o escríbeme por WhatsApp.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-2xl border border-ink/10 bg-bg-primary px-5 py-3.5 text-base text-ink placeholder:text-ink-muted focus:border-sage focus:outline-none focus:ring-2 focus:ring-sage/30 transition-colors duration-200";

  return (
    <form onSubmit={submit} data-testid={testId} className="space-y-4">
      <div className={compact ? "space-y-4" : "grid gap-4 sm:grid-cols-2"}>
        <input required value={form.name} onChange={update("name")} placeholder="Nombre" aria-label="Nombre" data-testid={`${testId}-name`} className={inputCls} />
        <input required type="email" value={form.email} onChange={update("email")} placeholder="Email" aria-label="Email" data-testid={`${testId}-email`} className={inputCls} />
      </div>
      <input required value={form.phone} onChange={update("phone")} placeholder="Teléfono" aria-label="Teléfono" data-testid={`${testId}-phone`} className={inputCls} />
      <textarea required value={form.message} onChange={update("message")} placeholder="Cuéntame brevemente en qué puedo ayudarte" aria-label="Mensaje" rows={compact ? 3 : 5} data-testid={`${testId}-message`} className={inputCls} />

      <label className="flex items-start gap-3 text-sm text-ink" data-testid={`${testId}-consent-label`}>
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          data-testid={`${testId}-consent`}
          className="mt-1 h-5 w-5 shrink-0 rounded border-ink/30 text-sage focus:ring-sage"
        />
        <span>
          He leído y acepto la{" "}
          <Link to="/politica-privacidad" className="underline underline-offset-2 hover:text-sage-dark">
            Política de Privacidad
          </Link>
          .
        </span>
      </label>
      <p className="text-sm leading-relaxed text-ink-muted">
        Tus datos serán tratados por {SITE.name} (Colegiada nº {SITE.colegiada}) con la única finalidad de gestionar
        tu solicitud de cita o consulta. Puedes ejercer tus derechos de acceso, rectificación y supresión en {SITE.email}.
      </p>

      <button
        type="submit"
        disabled={loading}
        data-testid={`${testId}-submit`}
        className="inline-flex items-center justify-center gap-2 rounded-full bg-ink px-8 py-4 text-sm font-medium text-bg-primary transition-colors duration-300 hover:bg-sage-dark disabled:opacity-60"
      >
        {loading && <Loader2 className="h-4 w-4 animate-spin" />}
        {loading ? "Enviando…" : "Enviar solicitud"}
      </button>
    </form>
  );
};
